import { QuoteHistoryItem } from "./types";
import { calculateAforoKg, calculateVolumeCm3 } from "./presets";

function getDeliveredTypeLabel(type: string) {
  if (type === "D") return "Domicilio";
  if (type === "S") return "Sucursal";
  if (type === "ALL") return "Domicilio + Sucursal";
  return type || "-";
}

function getCsvSafeValue(value: unknown) {
  return `"${String(value ?? "").replace(/"/g, '""')}"`;
}

export function downloadCsv(history: QuoteHistoryItem[]) {
  downloadCsvWithName(history, "lynxpack-cotizaciones");
}

export function downloadCsvByDeliveredType(
  history: QuoteHistoryItem[],
  deliveredType: "D" | "S",
  filePrefix: string
) {
  const filteredHistory = history
    .map((item) => ({
      ...item,
      results: item.results.filter(
        (result) => result.deliveredType === deliveredType
      ),
    }))
    .filter((item) => item.results.length > 0);

  downloadCsvWithName(filteredHistory, filePrefix);
}

export function downloadCsvWithName(
  history: QuoteHistoryItem[],
  filePrefix: string
) {
  const headers = [
    "Fecha",
    "Modo",
    "OK",
    "CP Origen",
    "CP Destino",
    "Tipo Entrega",
    "Producto",
    "Servicio",
    "Precio",
    "SLA",
    "SLA Min",
    "SLA Max",
    "Peso Real g",
    "Peso Real kg",
    "Alto cm",
    "Ancho cm",
    "Largo cm",
    "Volumen cm3",
    "Peso Aforado kg",
    "Peso Facturable kg",
    "Vigencia Correo",
    "Error",
  ];

  const rows = history.flatMap((item) => {
    const weightG = Number(item.weight);
    const weightKg = Number((weightG / 1000).toFixed(2));
    const height = Number(item.height);
    const width = Number(item.width);
    const length = Number(item.length);
    // Lo que calculó y guardó el servidor manda. El cálculo local queda como
    // respaldo para las cotizaciones que se hicieron antes de persistirlas.
    const volumeCm3 = item.volumeCm3 ?? calculateVolumeCm3({ height, width, length });
    const aforoKg = item.aforoKg ?? calculateAforoKg({ height, width, length });
    const billableKg = item.billableKg ?? Math.max(weightKg, aforoKg);

    if (item.results.length === 0) {
      return [
        [
          item.createdAt,
          item.mode,
          "NO",
          item.postalCodeOrigin,
          item.postalCodeDestination,
          getDeliveredTypeLabel(item.deliveredType),
          "",
          "",
          "",
          "",
          "",
          "",
          weightG,
          weightKg,
          height,
          width,
          length,
          volumeCm3,
          aforoKg,
          billableKg,
          item.validTo || "",
          item.error || "",
        ],
      ];
    }

    return item.results.map((result) => [
      item.createdAt,
      item.mode,
      "SI",
      item.postalCodeOrigin,
      item.postalCodeDestination,
      getDeliveredTypeLabel(result.deliveredType || item.deliveredType),
      result.productType || "",
      result.service,
      result.price,
      result.sla,
      result.deliveryTimeMin || "",
      result.deliveryTimeMax || "",
      weightG,
      weightKg,
      height,
      width,
      length,
      volumeCm3,
      aforoKg,
      billableKg,
      item.validTo || "",
      item.error || "",
    ]);
  });

  const csv = [headers, ...rows]
    .map((row) => row.map(getCsvSafeValue).join(","))
    .join("\n");

  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.download = `${filePrefix}-${new Date().toISOString().slice(0, 10)}.csv`;
  link.click();

  URL.revokeObjectURL(url);
}